<template>
  <div class="header-page">
    <img class="header-img" src="@/assets/header.jpg" alt="header">
    <img class="header-phone" src="@/assets/header-phone.jpg" alt="header">
    <img class="logo" src="@/assets/logo.png" alt="logo">
    <div class="title">{{ config.title }}</div>
    <div class="download-group">
      <img class="download-btn" style="margin-right: 30px;" src="@/assets/apple-btn.png">
      <img class="download-btn" src="@/assets/gp-btn.png" >
    </div>
  </div>
</template>
<script>
import config from "../config.js";
export default {
  data() {
    return {
      config,
    }
  }
}
</script>
<style lang="scss" scoped>
.header-page{
  position: relative;
  background: #fff;
  width: 100%;
  height: 870px;
  .header-img{
    width: 100%;
    height: 535px;
  }
  .header-phone{
    display: none;
  }
  .logo{
    position: absolute;
    top: 340px;
    left: 835px;
    width: 250px;
    height: 250px;
  }
  .title{
    width: 100%;
    margin-top: 60px;
    text-align: center;
    font-size: 50px;
    font-weight: 600;
    color: #000;
  }
  .download-group{
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 40px;
    .download-btn{
      width: 260px;
      height: 80px;
    }
  }
}
@media screen and (max-width: 768px) {
  .header-page{
    height: 1160px;
    .header-img{
      display: none;
    }
    .header-phone{
      width: 100%;
      height: 850px;
      display: block;
    }
    .logo{
      top: 680px;
      left: 250px;
    }
    .title{
      font-size: 42px;
      margin-top: 100px;
    }
    .download-group{
      margin-top: 30px;
    }
  }
}
</style>